"use client"

import { getCountryFlagImageUrl } from "@/utils/country/countryFlagEmoji"
import { faGlobe } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { FC, useEffect, useState } from "react"

type CountryFlagProps = {
  code?: string | null
  className?: string
  size?: number
}

const CountryFlag: FC<CountryFlagProps> = ({ code, className, size = 20 }) => {
  const imageUrl = getCountryFlagImageUrl(code, size * 2)
  const [imageFailed, setImageFailed] = useState(false)

  useEffect(() => {
    setImageFailed(false)
  }, [imageUrl])

  if (!imageUrl || imageFailed) {
    return (
      <span
        className={`country-flag country-flag--fallback ${className ?? ""}`}
        style={{ width: size, height: size }}
        aria-hidden
      >
        <FontAwesomeIcon icon={faGlobe} style={{ fontSize: size * 0.55 }} />
      </span>
    )
  }

  return (
    <span
      className={`country-flag ${className ?? ""}`}
      style={{ width: size, height: size }}
    >
      <img
        src={imageUrl}
        alt=""
        width={size}
        height={size}
        loading="lazy"
        decoding="async"
        referrerPolicy="no-referrer"
        onError={() => setImageFailed(true)}
      />
    </span>
  )
}

export default CountryFlag
